import { getToken } from '@verantos-dev/core-auth';
import { getBaseApiUrl, getGatewayApiVersion } from '@verantos-dev/core-constants';

/**
 * Auth-aware fetch for TanStack Query hooks under `data-access-cohorts`.
 * Mirrors the gen-3 cohort-builder and analytical-variables fetcher
 * implementations. Lifted here once a second domain needed TanStack reads;
 * promote to `@verantos-dev/core-utils` once a third domain adopts the
 * same pattern.
 */
export async function authFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const baseUrl = `${getBaseApiUrl()}/${getGatewayApiVersion()}`;
  const token = await getToken();

  const response = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status} ${response.statusText}`);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return response.json();
}
